// Components
import { IconFlag, IconGitFork } from '@u21/tabler-icons';
import {
  U21Chip,
  U21Spacer,
  U21Subsection,
  U21Tooltip,
} from 'app/shared/u21-ui/components';
import styled, { useTheme } from 'styled-components';

// Models
import { EvaluationLogFlow } from 'app/shared/eventsOld/models';

// Utils
import { DECISION_MAP } from 'app/modules/rules/constants';
import { FlowChip } from 'app/modules/detectionModels/components/FlowChip';
import { RuleChip } from 'app/modules/detectionModels/components/RuleChip';
import { RuleFlowStatus } from 'app/modules/ruleFlows/models';
import { RuleIcon } from 'app/modules/detectionModels/components/RuleIcon';
import { RuleStatuses, RtrDecision } from 'app/modules/rules/models';
import { ROUTES_MAP } from 'app/shared/utils/routes';
import { DECISION_ICON_MAP } from 'app/modules/detectionModels/constants';

interface Props {
  flow: EvaluationLogFlow;
}

const DECISION_PALETTE_MAP: Record<
  RtrDecision,
  'error' | 'success' | 'warning'
> = {
  [RtrDecision.ALLOW]: 'success',
  [RtrDecision.DENY]: 'error',
  [RtrDecision.ERROR]: 'error',
  [RtrDecision.STEP_UP_AUTHENTICATION]: 'warning',
};

export const SidebarFlowTriggeredInfo = ({ flow }: Props) => {
  const { palette } = useTheme();

  const DecisionIcon = DECISION_ICON_MAP[flow.decision];
  const decisionColor = palette[DECISION_PALETTE_MAP[flow.decision]].main;
  const flowDetailPath = ROUTES_MAP.flowDetail.path
    .replace(':id', String(flow.id))
    .replace('/:tab?', '');

  return (
    <U21Subsection
      collapsed
      collapsible
      shadedHeader
      title="Flow Triggered"
      titleIcon={<IconGitFork />}
    >
      <U21Spacer spacing={1}>
        <SpaceBetweenDiv>
          <FlowChip
            flow={{
              id: flow.id,
              status: RuleFlowStatus.ACTIVE,
              title: flow.name,
            }}
          />
          <U21Spacer horizontal>
            <U21Tooltip
              tooltip={`Flow decision: ${DECISION_MAP[flow.decision]}`}
            >
              <DecisionIcon style={{ color: decisionColor }} />
            </U21Tooltip>
            {flow.alert_generated && (
              <U21Tooltip tooltip="This evaluation triggered an alert">
                <IconFlag style={{ color: palette.error.main }} />
              </U21Tooltip>
            )}
          </U21Spacer>
        </SpaceBetweenDiv>
        <div>
          {flow.decision_source ? (
            <RuleChip
              rule={{
                id: flow.decision_source.node_id,
                status: RuleStatuses.ACTIVE,
                title: flow.decision_source.node_name,
              }}
            />
          ) : (
            <U21Chip
              icon={<RuleIcon status={RuleStatuses.ACTIVE} />}
              to={flowDetailPath}
            >
              Default node
            </U21Chip>
          )}
        </div>
      </U21Spacer>
    </U21Subsection>
  );
};

const SpaceBetweenDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
